import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { OperatorQueryFilter } from '../../shared/types';
import { CITRIN_GET_OPERATORS, GetOperatorsRequest, GetOperatorsResponse } from '..';

export const useGetOperatorsQuery = (request: OperatorQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: OperatorQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetOperatorsResponse, GetOperatorsRequest>(CITRIN_GET_OPERATORS, {
        variables: { request: internalRequest },
        fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Users', data),
    });

    return { ...rest, previousData: previousData?.CITRIN_MGT_getOperators, data: data?.CITRIN_MGT_getOperators ?? [] };
};
